import React, { useState } from 'react';
import cn from 'classnames';

import { useTranslation, useResponsive } from 'client/hooks';
import { thousandSeparator } from 'utils/thousand-separator';

import Icon from '../../../Icon';

import css from './ReactionsDetailsDrawerButton.module.scss';

interface Props {
  className?: string;
  totalReactions: number;
  openReactionsDrawer: () => void;
  isReactionsDrawerOpen: boolean;
}

const ReactionsDetailsDrawerButton: React.FC<Props> = (props) => {
  const { className = '', openReactionsDrawer, totalReactions, isReactionsDrawerOpen } = props;
  const { translate } = useTranslation('actionsPanel');
  const [isActiveBtn, setIsActiveBtn] = useState<boolean>(false);
  const [isMobile] = useResponsive('MOBILE');

  const clickOnBtn = () => {
    if (!isReactionsDrawerOpen) {
      setIsActiveBtn(true);
      openReactionsDrawer();
    }
  };

  React.useEffect(() => {
    if (!isReactionsDrawerOpen) {
      setTimeout(() => {
        setIsActiveBtn(false);
      }, 300);
    }
  }, [isReactionsDrawerOpen]);

  return (
    <div className={cn(css.reactionsButton, className)}>
      <div className={cn(css.btn, isActiveBtn && css.active)} onClick={clickOnBtn}>
        <div className={css.iconWrapper}>
          <Icon type="reactions-statistics" className={cn(css.icon, isActiveBtn && css.active)} />
        </div>

        <div className={css.name}>
          {translate('btns.detailedReactionsBtn')}&nbsp;
          {!isMobile && totalReactions > 0 && <>({thousandSeparator(totalReactions)})</>}
        </div>
        {isMobile && totalReactions > 0 && (
          <div className={css.reactionsCounter}>({thousandSeparator(totalReactions)})</div>
        )}
      </div>
    </div>
  );
};

export default ReactionsDetailsDrawerButton;
